import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import AuthenticatedRoute from './views/Authentication/AuthenticatedRoute.jsx';
import {USER_NAME_SESSION_ATTRIBUTE_NAME} from "./service/AuthenticationService";
import axios from "axios";

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Register = React.lazy(() => import('./views/Pages/Register'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));
const AgentCC = React.lazy(() => import('./views/Pages/AgentCC'));
const AgentCCV1 = React.lazy(() => import('./views/Pages/AgentCCV1'));
const Test = React.lazy(() => import('./views/Pages/Test'));
const ActivateAccount = React.lazy(() => import('./views/Pages/ActivateAccount'));
const Recruits = React.lazy(() => import('./views/Pages/Recruits'));

class App extends Component {

  constructor(props, context) {
    super(props, context);

    const paramsHash = window.location.hash;

    const parametersStart = paramsHash.indexOf("token=");
    if(parametersStart>0) {
      const parameters = paramsHash.substr(paramsHash.indexOf("?")+1, paramsHash.length);
      const params = new URLSearchParams(parameters);
      const token = params.get('token');
      const user = params.get('user');
      sessionStorage.setItem('token', 'Bearer ' +token)
      sessionStorage.setItem("authenticatedUser", user)

        axios.interceptors.request.use(
            (config) => {
                config.headers.authorization = 'Bearer ' + token
                sessionStorage.setItem('token', 'Bearer ' +token)
              return config
            }
        )
    }else{
      console.log("no params")
    }
  }

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/recruits" name="Aplikuj" render={props => <Recruits {...props}/>} />
              <Route exact path="/recruits/:src" name="Aplikuj" render={props => <Recruits {...props}/>} />
              <Route exact path="/recruitment/:id" name="Aplikuj" render={props => <Recruits {...props}/>} />
              <Route exact path="/activate/:mode/:hash/" name="Activate Account" render={props => <ActivateAccount {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <AuthenticatedRoute path="/agent-cc" name="Agent CC" render={props => <AgentCC {...props}/>} />
              <AuthenticatedRoute path="/agent-cc-v1" name="Agent CC V1" render={props => <AgentCCV1 {...props}/>} />
              <AuthenticatedRoute path="/test" name="Test" render={props => <Test {...props}/>} />
              <AuthenticatedRoute path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
